import Vue from "vue";

const error = {
  install(Vue) {
    Vue.prototype.$getError = function (e) {
      console.log("422");
      if (e.response) {
        if (e.response.data) {
          const code = parseInt(e.response.data.code);
          switch (code) {
            case 401:
              Vue.prototype.$auth.logout();
              window.location.reload(false);
              return false;
            case 403:
              this.$toast.error(
                "خطای 403 ",
                "شما دسترسی لازم به این صفحه را ندارید، لطفا مجددا وارد شوید",
                {
                  position: "topLeft",
                  rtl: true,
                }
              );
              return false;
            case 404:
              this.$toast.error("خطای 404", "صفحه مورد نظر یافت نشد", {
                position: "topLeft",
                rtl: true,
              });
              return false;
            case 422:
              const slugError = e.response.data?.errors?.slug;
              const bodyError = error.response.data?.errors?.body;

              let errorText = "لطفا مقادیر وارد شده در فرم را بررسی نمایید.";

              if (slugError) {
                errorText = "Slug وارد شده تکراری هست. لطفا آن را تغییر دهید.";
              } else if (bodyError) {
                errorText = "فیلد توضیحات نمی تواند خالی باشد!";
              }

              Vue.prototype.$swal({
                type: "warning",
                text: errorText,
                confirmButtonColor: "#2632d6",
                confirmButtonText: "تایید",
              });

              return false;
            case 500:
              this.$toast.error(
                "خطای 404",
                "مشکلی در اتصال به سرور به وجود آمده است. لطفا مجددا تلاش نمایید",
                {
                  position: "topLeft",
                  rtl: true,
                }
              );
              return false;
            default:
              if (Array.isArray(e.response.data.message))
                e.response.data.message.forEach((item) =>
                  this.$toast.error(item)
                );
              if (typeof e.response.data.message == "object")
                Object.keys(e.response.data.message).forEach((item) =>
                  this.$toast.error(item)
                );
          }
        }
      } else if (typeof e == "string") {
        this.$toast.error(e);
        console.error(e);
      }
    };
  },
};
Vue.use(error);

export default error;
